export const SECTIONS = [
  { n: 1, slug: "soggetto", it: "Soggetto e Azione", en: "Subject & Action" },
  { n: 2, slug: "ambientazione", it: "Ambientazione e Sfondo", en: "Setting & Background" },
  { n: 3, slug: "stile", it: "Stile Visivo e Estetica", en: "Visual Style & Aesthetics" },
  { n: 4, slug: "illuminazione", it: "Illuminazione e Colore", en: "Lighting & Color Palette" },
  { n: 5, slug: "inquadratura", it: "Inquadratura e Composizione", en: "Camera & Composition" },
  { n: 6, slug: "prompt", it: "Prompt Sintetico Ricostruito", en: "Reconstructed Prompt" },
];

export function parseSections(text) {
  const out = {};
  const re = /^#{1,4}\s*\**\s*([1-6])\.?[^\n]*$/gm;
  const marks = [];
  let m;
  while ((m = re.exec(text)) !== null) marks.push({ n: Number(m[1]), start: m.index, end: re.lastIndex });
  marks.forEach((mk, i) => {
    const stop = i + 1 < marks.length ? marks[i + 1].start : text.length;
    out[mk.n] = text.slice(mk.end, stop).trim();
  });
  return { sections: out, current: marks.length ? marks[marks.length - 1].n : 0 };
}

export function cleanPrompt(s = "") {
  return s.replace(/^```[a-z]*\n?|```$/gi, "").trim().replace(/^"|"$/g, "").trim();
}

export function buildFullText(sections, prompt) {
  return SECTIONS.map((s) => {
    const body = s.n === 6 ? prompt : sections[s.n] || "";
    return `${s.n}. ${s.it} (${s.en})\n${body}`;
  }).join("\n\n");
}
